/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Vs_Verdict_DescInputs */

const en_fc_vs_verdict_desc = /** @type {(inputs: Fc_Vs_Verdict_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consider FilmCraft for learning, personal projects and exploring an open-source workflow. Premiere Pro may be a better fit when you depend on established plugins, team workflows or existing Adobe projects. Test your own footage and delivery requirements before switching.`)
};

/**
* | output |
* | --- |
* | "Consider FilmCraft for learning, personal projects and exploring an open-source workflow. Premiere Pro may be a better fit when you depend on established plu..." |
*
* @param {Fc_Vs_Verdict_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_vs_verdict_desc = /** @type {((inputs?: Fc_Vs_Verdict_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Vs_Verdict_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_vs_verdict_desc(inputs)
});
export { fc_vs_verdict_desc as "fc.vs.verdict.desc" }